import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import DocumentMeta from './components/DocumentMeta';
import HashScroll from './components/HashScroll';
import { Analytics } from '@vercel/analytics/react';
import { BookingProvider } from './context/BookingContext';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import ProofStrip from './components/ProofStrip';
import Pain from './components/Pain';
import DiagnosticChat from './components/DiagnosticChat';
import HowItWorks from './components/HowItWorks';
import AssistantDemo from './components/AssistantDemo';
import Pricing from './components/Pricing';
import WhyCure8 from './components/WhyCure8';
import FAQ from './components/FAQ';
import FaqJsonLd from './components/FaqJsonLd';
import CTA from './components/CTA';
import Footer from './components/Footer';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import './App.css';

const HomePage = () => (
  <>
    <FaqJsonLd />
    <Hero />
    <ProofStrip />
    <Pain />
    <HowItWorks />
    <AssistantDemo />
    <Pricing />
    <WhyCure8 />
    <DiagnosticChat />
    <FAQ />
    <CTA />
  </>
);

function App() {
  return (
    <BookingProvider>
      <Router>
        <div className="App site-title-case">
          <DocumentMeta />
          <HashScroll />
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-of-service" element={<TermsOfService />} />
            </Routes>
          </main>
          <Footer />
          <Analytics />
        </div>
      </Router>
    </BookingProvider>
  );
}

export default App;
